<template id="shoppingCart">
<section class="historyPage" id="orderlist">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="formHeadings"> <span><img src="@/images/statisticthumb.png" alt="#"></span>{{res.stat}}</div>
      </div>
      <div class="threeOuter">
        <div class="col-md-4 col-sm-4 col-xs-6" v-if="lastOrderDate != null">
          <div class="usefulStatistic">
            <div class="statisticIcons"><img src="@/images/statisticthumb1.png" alt="#"></div>
            <div class="statisticInfo">
              <div class="statisticInfoText">
                <p v-if="lastOrderDate != null">{{res.ordersince}}<br>
                  <span>{{lastOrderDate | fullDate(common_res.month['m'+(lastOrderDate.getMonth()+1)], common_res.fullym)}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-6" v-if="ranking != null && (ranking.lpos || ranking.gpos)">
          <div class="usefulStatistic">
            <div class="statisticIcons"><img src="@/images/statisticthumb2.png" alt="#"></div>
            <div class="statisticInfo">
              <div class="statisticInfoText">
                <!--p><span>{{res.top}} 5</span> in Hong Kong</p-->
                <!--p><span>{{res.top}} 100</span> {{res.globally}}</p-->
                <p v-if="ranking.lpos" v-html="subVals(res.top_locally, [ranking.lpos, companyinfo.country_name])"></p>
                <p v-if="ranking.gpos" v-html="subVals(res.top_globally, [ranking.gpos])"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-6" v-if="discountShown != null">
          <div class="usefulStatistic">
            <div class="statisticIcons"><img src="@/images/statisticthumb3.png" alt="#"></div>
            <div class="statisticInfo">
              <div class="statisticInfoText">
                <p>{{discountShown.name}}<br>
                  <span>{{-1 * discountShown.dprice * 100 | format('#')}}%</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12" v-if="report.length > 0">
        <div class="formHeadings customHeading"> <span><img src="@/images/purchase.png" alt="#"></span>{{res.totalpur}}</div>
      </div>
      <div class="col-lg-9 col-md-8 col-sm-8 col-xs-12" v-if="report.length > 0">
        <div class="graphThumb">
          <lineChart styles="myStyles" :width="300" :height="256" :options="chartOpt" :chart-data="datacollection"></lineChart>
	</div>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-4 col-xs-3 hidden-xs" v-if="report.length > 0">
        <div class="table-responsive">
          <table class="table01">
            <tbody>
            <tr v-for="(stat, sidx) in stats">
              <td class="black"><nobr>{{stat.ym}}</nobr></td>
              <td>{{stat[report_total] | format()}}</td>
              <td :class="stat.st">{{stat.chg}}</td>
            </tr>
          </tbody></table>
        </div>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-12 visible-xs" v-if="report.length > 0">
        <div class="table-responsive">
          <table class="table01">
            <tbody>
            <tr>
              <td class="black" v-for="(stat, sidx) in mstats">{{stat.ym}}</td>
            </tr>
            <tr>
              <td v-for="(stat, sidx) in mstats">{{stat[report_total] | format()}}</td>
            </tr>
            <tr>
              <td :class="stat.st" v-for="(stat, sidx) in mstats">{{stat.chg}}</td>
            </tr>
          </tbody></table>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="table-responsive">
          <div id="no-more-tables">
            <table class="table-bordered  cf table02">
              <thead class="cf">
                <tr>
                  <th class="numeric">{{res.invoiceno}}</th>
                  <th class="numeric">{{res.orderdate}}</th>
                  <th class="numeric">{{res.orderstatus}}</th>
                  <th class="numeric">{{res.ordertotal}}</th>
                  <th class="numeric mobhidden">{{res.invoice}} {{res.pdf}}</th>
                  <th class="numeric mobhidden">{{res.receipt}} {{res.pdf}}</th>
                  <th class="numeric mobhidden">{{res.packing}} {{res.pdf}}</th>
                  <th class="numeric mobvisible">{{res.pdf}}</th>
                </tr>
              </thead>
              <tbody>
                <tr :class="(oidx % 2 == 0)?'lightGrey':'darkGrey'" v-for="(order, oidx) in orders">
                  <td :style="isOwner(order)?'cursor:pointer':'font-style:italic;cursor:pointer'" :data-title="res.invoiceno" v-on:click="goDetails(order)">{{order.invcode}}</td>
                  <td :data-title="res.orderdate">{{order.createdate}}</td>
                  <td :data-title="res.orderstatus" class="numeric">
                    <div v-if="isCancelled(order)">{{res.cancelled}}</div>
                    <div v-else-if="isOutStanding(order)">{{res.outstanding}}</div>
                    <div v-else-if="isDelivered(order)">{{res.delivered}}</div>
                    <div v-else-if="isPacked(order)">{{res.dispatched}}</div>
                    <div v-else-if="isReadyToPay(order)">{{res.readytopay}}</div>
                    <div v-else-if="isPaid(order)">{{res.paid}}</div>
                    <div v-else-if="isConfirmed(order)">{{res.confirmed}}</div>
                    <div v-else>{{res.processing}}</div>
                  </td>
                  <td v-if="order.currency == ''" :data-title="res.ordertotal" class="numeric"> <span style="padding:0;font-size:70%">{{curr}}</span> {{order.total | format()}} </td>
                  <td v-else :data-title="res.ordertotal" class="numeric"><span style="padding:0;font-size:70%">{{order.currency}}</span>&nbsp;{{order.total | format(getFmt(order))}} </td>
                  <td :data-title="res.invoice+' ' +res.pdf" class="numeric numeric1">
                    <a v-if="isFile(order, 'invoice')" v-on:click="downloadPDF(order.invcode)" href="javascript:void(0)"><span>{{res.invoice}}</span><img class="img-responsive" src="@/images/pdf.png" alt=""></a>
                    <a style="width:100%" v-else><span style="padding:0px">--</span></a>
                  </td>
                  <td :data-title="res.receipt+' ' +res.pdf" class="numeric numeric1">
                    <a v-if="isFile(order, 'receipt') && (isPaid(order))" v-on:click="downloadPDF(order.invcode+'_receipt')" href="javascript:void(0)"><span>{{res.receipt}}</span><img class="img-responsive" src="@/images/pdf.png" alt=""></a>
                    <a style="width:100%" v-else><span style="padding:0px">--</span></a>
                  </td>
                  <td :data-title="res.packing+' ' +res.pdf" class="numeric numeric1">
                    <a v-if="isFile(order, 'dnote') && (isDelivered(order) || isPacked(order))" v-on:click="downloadPDF(order.invcode+'_dnote')" href="javascript:void(0)"><span>{{res.packing}}</span><img class="img-responsive" src="@/images/pdf.png" alt=""></a>
                    <a style="width:100%" v-else><span style="padding:0px">--</span></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>
<script>

import utils from './Utils.vue'
import orderProduct from './OrderProduct.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);
import lineChart from '../lib/LineChart.js'
import { Color } from 'vue-chartjs'

function readURL(input, func) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      func(e.target.result);
    }
    reader.readAsDataURL(input.files[0]);
  }
}

export default {
  name: 'cart',
  props:['_files', 'ranking', 'name', '_orders', 'report', 'countries', 'res', 'discountlist', 'common_res', 'companyinfo'],
  data () {
    return {
      locale:null,
      curr:null,
      report_total:'chg_total',
      orders:[],
      stats:null,
      mstats:null,
      num:-1,
      height:256,
      datacollection:null,
      chartOpt:{
        maintainAspectRatio: false,
        spanGaps: false,
        elements: {
          line: {
            tension: 0.000001
          }
        },
        legend: {
          labels: {
            filter: function(label) {
              if (label.text != 'Estimated') return true; //only show when the label is cash
            }
          }
        },
        tooltips:{
          callbacks:{
            title:function() {
              return '';
            },
            label:function(tooltipItem, data) {
              //console.log(tooltipItem, data);
              if (tooltipItem.datasetIndex == 2 && tooltipItem.index < data.labels.length-1) {
                return null;
              }
              
              return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
            }
          }
        },
        plugins: {
          filler: {
            propagate: false
          }
        },
        scales: {
          yAxes:[{
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            ticks: {
              autoSkip: false,
              maxRotation: 0
            }
          }]
        }
      },
      products:[],
      amts:[],
      amts_to_day:[],
      token:null,
      yrshown:5,
      submitted:false,
      estimated:null,
      error:{}
    }
  },
  components: {
    orderProduct,
    lineChart
  },
  created: function() {
    this.loadOrders();
    this.curr = utils.getCurrencySym();
    this.stats = this.report.slice().reverse();
    if (this.stats && this.stats.length > 0) {
      this.stats[this.stats.length-1].chg = '';
      this.stats[this.stats.length-1].st= 'green';
      for (var i=0;i<this.stats.length-1;i++) {
        var stat = this.stats[i];
        //if (i == this.stats.length - 2) {
        if (i == 0) {
          this.stats[i][this.report_total] = this.stats[i].total_to_day;
          this.stats[i+1][this.report_total] = this.stats[i+1].total_to_day;
        } else {
          this.stats[i][this.report_total] = this.stats[i].total;
          this.stats[i+1][this.report_total] = this.stats[i+1].total;
        }
        if (this.stats[i+1][this.report_total] == 0) {
          if (this.res.infinity != null) stat.chg = this.res.infinity;
          stat.st = 'green';
        } else if (parseInt(stat[this.report_total]) > parseInt(this.stats[i+1][this.report_total])) {
          stat.chg = '(+' + Vue.filter('format')(parseInt((stat[this.report_total] - this.stats[i+1][this.report_total])*100)/this.stats[i+1][this.report_total]) + '%)';
          stat.st = 'green';
        } else {
          stat.chg = '(' + Vue.filter('format')(parseInt((stat[this.report_total] - this.stats[i+1][this.report_total])*100)/this.stats[i+1][this.report_total]) + '%)';
          stat.st = 'redClr';
        }
        //if (i == this.stats.length - 2) {
        if (i == 0) {
          this.stats[i][this.report_total] = this.stats[i].total;
          this.stats[i+1][this.report_total] = this.stats[i+1].total;
        }
      }
    }
    this.mstats = this.stats.slice().reverse();
    var self = this;
    this.locale = utils.getLocale();
    var curyear = new Date().getFullYear();
    for (var i=0;i<this.report.length;i++) {
      if ((curyear - this.report[i].ym) <= this.yrshown) {
        this.amts.push(Vue.filter('format')(this.report[i].total, '######.0'));
        this.amts_to_day.push(Vue.filter('format')(this.report[i].total_to_day, '######.0'));
      }
      //this.amts.push(numeral(parseFloat(this.report[i].total)).format('###,###,###.0'));
      //this.amts.push(this.report[i].total);
    }
    // if last figure is current year, then project the value
    if (this.report.length > 0 && this.report[this.report.length-1].ym == new Date().getFullYear()) {
      this.estimated = this.amts.slice(0, this.amts.length-1);
      var doy = Math.floor((Date.now() - Date.parse(new Date().getFullYear(), 0, 0)) / 86400000);
      var lastamt = this.amts[this.amts.length-1] / doy * 365;
      this.estimated.push(Vue.filter('format')(lastamt, '######.0'));
    }
  },
  computed: {
    discountInfo() {
      if (this.discountlist.length == 0) return;
      for (var i=0;i<this<discountlist.length;i++) {
        if (this.discountlist[i].prefix == 'TD' || this.discountlist[i].prefix == 'ND') {
          return this.discountlist[i];
        }
      }
    },
    discountShown() {
      if (this.discountlist == null || this.discountlist.length == 0) return null;
      for (var i=0;i<this.discountlist.length;i++) {
        if (this.discountlist[i].ctype == 'PT') {
          return this.discountlist[i];
        }
      }
      return null;
    },
    lastOrderDate() {
      if (this.companyinfo.firstdate == null || this.companyinfo.firstdate == '') return;
      //return new Date(Date.parse(this.orders[this.orders.length-1].createdate+' 00:00:00'));
      //return new Date(Date.parse(this.orders[0].createdate+' 00:00:00'));
      //var a = this.orders[this.orders.length-1].createdate.split(/[^0-9]/);
      var a = this.companyinfo.firstdate.split(/[^0-9]/);
      return new Date(a[0],a[1]-1,a[2], 0, 0, 0);
      var ym = this.orders[this.orders.length-1].ym;
      var info = ym.split('-');
      return this.common_res.month['m'+(parseInt(info[1]))] + ' ' + info[0];
    },
    myStyles () {
      return {
        height: `${this.height}px`,
        position: 'relative'
      }
    }
  },
  methods: {
    subVals:utils.subVals,
    getFmt(o) {
      if (o.ratedp != null) {
        return parseInt(o.ratedp);
      }
      return null;
    },
    goDetails(o) {
      window.location.href='details.html?invcode='+o.invcode;
    },
    isPacked(o) {
      return utils.getPackedStatus().indexOf(o.delivery_status_id) >= 0;
    },
    isOwner(o) {
      return o.bchfk == this.companyinfo.bchid;
    },
    isCancelled(o) {
      return o.order_id == null || o.order_id == '';
    },
    isDelivered(o) {
      return utils.getDeliveredStatus().indexOf(o.delivery_status_id) >= 0;
    },
    isConfirmed(o) {
      return !this.isCancelled(o) && o.picode != o.invcode;
    },
    isOutStanding(o) {
      return this.isDelivered(o) && !this.isPaid(o);
    },
    isFile(o, suffix) {
      if (o.files == null) return true;
      if (o.files.length == 0) return true;
      var file = o.files;
      if (file != null) {
        return file.indexOf(suffix) < 0;
      }
      return false;
    },
    isReadyToPay(o) {
      return utils.getReadyToPayStatus().indexOf(o.payment_status_id) >= 0;
    },
    isPaid(o) {
      return utils.getPaidStatus().indexOf(o.payment_status_id) >= 0;
    },
    downloadPDF(filecode) {
      window.open(utils.getServerContext()+'/~ws/'+filecode+'.pdf', '_blank');
      //window.location.href = utils.getServerContext()+'/~ws/'+filecode+'.pdf';
    },
    fillData () {
      var l = [];
      var curyear = new Date().getFullYear();
      for (var i=0;i<this.report.length;i++) {
        if ((curyear - this.report[i].ym) <= this.yrshown) {
          l.push(this.report[i].ym);
        }
      }
      var estimated_point = null;
      if (this.estimated != null) {
        estimated_point = {
            label: 'Estimated',
            //backgroundColor: this.cutils.transparentize(window.chartColors.red),
            backgroundColor: window.Color(window.chartColors.red).alpha(0.5).rgbString(),
            borderColor: window.chartColors.red,
            borderDash:[10, 5],
            fill: true,
            data : this.estimated
          };
      }
      this.datacollection = {
        labels : l,
        datasets: [
          {
            label:'Amts (YTD)',
            //backgroundColor: this.cutils.transparentize(window.chartColors.red),
            backgroundColor: window.Color(window.chartColors.green).alpha(0.5).rgbString(),
            borderColor: window.chartColors.green,
            fill: true,
            data : this.amts_to_day
          },
          {
            label: 'Amts',
            //backgroundColor: this.cutils.transparentize(window.chartColors.red),
            backgroundColor: window.Color(window.chartColors.red).alpha(0.5).rgbString(),
            borderColor: window.chartColors.red,
            fill: this.estimated == null,
            data : this.estimated==null?this.amts:this.amts.slice(0, this.amts.length-1),
          }
          /*{
            label: 'none',
            //backgroundColor: this.cutils.transparentize(window.chartColors.red),
            backgroundColor: window.Color(window.chartColors.red).alpha(0.5).rgbString(),
            borderColor: window.chartColors.red,
            borderDash:[10, 5],
            fill: true,
            data : this.amts
          }*/
        ]
      };
      if (estimated_point != null) {
        this.datacollection.datasets.push(estimated_point);
      } else {
        this.datacollection.datasets.splice(0, 1);
      }
    },
    chk: function(name, regex, errmsg) {
      // mandatory
      // if (0 == mode) {
      if (regex) {
        var chkval = (this.reseller[name])?this.reseller[name]:'';
        if (!regex.test(chkval)) {
          if (errmsg) this.error[name] = errmsg;
          else this.error[name] = " This is required";
//console.log('false:'+name+":"+chkval);
          return false;
        } else {
          delete this.error[name];
          return true;
        }
      }
      // }
    },
    getText(node) {
      var d = $('<div>'+(node)+'</div>');
      return d.text();
    },
    removeErr: function(evt, name) {
      console.log(name);
      delete this.error[name];
      this.$forceUpdate();
    },
    loadOrders() {
      var self = this;
      if (self.loading) return;
      self.loading = true;
      var suffix = "?"+new Date().getTime();
      if (this.num > 0) {
        suffix = suffix+"&start="+self.orders.length;
      }
      Vue.http.get(utils.getServerPath()+'/order/orders.is'+suffix).then(response => {
        var o = response.body.orders;
        var f = response.body.files;
        if (this.num == -1) this.num = o.length;
        for (var i=0;i<o.length;i++) {
          if (f != null) {
            o[i].files = f[o[i].invcode];
          }
          this.orders.push(o[i]);
        }
        self.loading = false;
        if (o.length == 0) self.allLoaded = true;
      }, response => {
        console.log('err', response);
        self.loading = false;
      });
    }
  },
  mounted: function() {
    this.fillData();
    var self = this;
    this.$root.$on('scroll', data => {
      if (data == 'bottom') {
        if (self.allLoaded) return;
        if (self.pagination == null) {
          self.loadOrders();
        }
      }
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OrderList.vue